const headers = {
  name: "Products",
  navigate: {
    path: [
      {
        name: "Expiry",
        path: "/app/inventory/expiry",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
